import React from 'react';
import { useRouter } from 'next/router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from '@/helpers/Link';
import t from '@/utils/Language/Collection-translations';
import Button from '@/components/Button/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import classes from './Collection.module.scss';

const CollectionHeader = ({ collection }) => {
  const router = useRouter();

  const renderIcon = (sharedStatus) => {
    let icon = '';
    switch (sharedStatus) {
      case 0:
        icon = 'lock';
        break;
      case 1:
        icon = 'sitemap';
        break;
      case 2:
        icon = 'globe';
        break;
      case 3:
        icon = 'globe';
        break;
    }
    return icon;
  };

  const renderCollectionAuthor = () => {
    return (
      <>
        {collection.organization_fetchable_id && (
          <>
            <span>{t('Created by')}&nbsp;</span>
            <span>
              <Link href={'/org/' + collection.organization_fetchable_id}>{collection?.author}</Link>
            </span>
          </>
        )}
        {!collection.organization_fetchable_id && (
          <>
            <span>{t('Created by')}&nbsp;</span>
            <span>{collection?.author}</span>
          </>
        )}
      </>
    );
  };

  const redirectToMyCollection = () => {
    router.push('/collections?page=my');
  };

  const statusBadge = () => {
    let sharedStatus = '';
    switch (collection.shared_status) {
      case 0:
        sharedStatus = t('Private collection');
        break;
      case 1:
        sharedStatus = t('Organization collection');
        break;
      case 2:
        sharedStatus = t('Public collection');
        break;
      case 3:
        sharedStatus = t('Public affiliated collection');
        break;
    }

    return (
      <span className={classes.collectionStatus}>
        <FontAwesomeIcon icon={['fas', renderIcon(collection.shared_status)]} />
        &nbsp;
        {sharedStatus}
      </span>
    );
  };

  return (
    <Row>
      <Col xs="12">
        {/* Button row: status badge inline on desktop, hidden on mobile */}
        <Row className="align-items-center mb-2">
          <Col>
            <Button
              dataCy="button-my-collection"
              type="secondary"
              icon={{ style: 'fas', font: 'book' }}
              text={t('My Collections')}
              border={true}
              onButtonClick={redirectToMyCollection}
            />
          </Col>
          <Col xs="auto" className="d-none d-md-block">
            {statusBadge()}
          </Col>
        </Row>

        <div className={classes.collectionTitle}>
          <h1>
            <Link href={`/collections/${collection.slug}`} data-cy="card-collection-name" className={classes.collectionTitleLink}>
              {collection.title}
            </Link>
          </h1>
        </div>

        <div className={classes.collectionMeta}>
          {collection?.region && <span className={`${classes.collectionRegion} ${classes.collectionRegionItem}`}>{collection?.region}</span>}
          <span className={classes.collectionAuthorCount}>
            {renderCollectionAuthor()}
            {collection?.resource_count_total > 0 && (
              <span className={classes.resourceCount}>
                &nbsp; -{' '}
                {t(collection?.resource_count_total > 1 ? '${count} resources' : '${count} resource', { count: collection?.resource_count_total })}
              </span>
            )}
          </span>
        </div>

        {/* Status badge: mobile only */}
        <div className={`d-md-none ${classes.collectionStatusMobileRow}`}>{statusBadge()}</div>
      </Col>
    </Row>
  );
};

export default CollectionHeader;
